'use client'

import Script from 'next/script'
import React from 'react'
import { useCookieConsent } from '@/global/hooks/useCookieConsent'

const RMD_CONSENT_CATEGORY = 'performance'

export const RmdAnalyticsScript = () => {
  const websiteId = process.env.NEXT_PUBLIC_APP_RMD_WEBSITE_ID
  const consentGranted = useCookieConsent(RMD_CONSENT_CATEGORY)

  if (!websiteId) return null
  if (!consentGranted) return null

  return (
    <Script
      id='rmd-analytics'
      strategy='lazyOnload'
      src='https://analytics.rmd-studio.com/rmd.js'
      data-website-id={websiteId}
      data-cfasync='false'
    />
  )
}
